// import React from "react";
// import SubAccessControlHead from "./TableHead/SubAccessControlHead";
// import SubAccessControlBody from "./TableBody/SubAccessControlBody";

// const SubAccessControlTable = ({
//   permissionsAccessControl,
//   accessControls,
//   handleDelete,
//   status,
//   handleOpenPopup,
// }) => {
//   return (
//     <div className="row">
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table>
//                 <SubAccessControlHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />

//                 <SubAccessControlBody
//                   accessControls={accessControls}
//                   handleOpenPopup={handleOpenPopup}
//                   handleDelete={handleDelete}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetSubAccessControlTableColumns from "./ColumnDefinition/AccessControlColumn/GetSubAccessControlTableColumns";
import { mapSubAccessControlToDataTable as mapData } from "./Helper";

const SubAccessControlTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
}) => {
  const columns = GetSubAccessControlTableColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default SubAccessControlTable;
